import { useEffect, useState } from 'react';

import { useGetMaxCLASettings } from 'queries';
import { isNil } from 'ramda';
import { useTranslation } from 'react-i18next';

import { ConvertedMaxCLASetting, MaxCLASetting } from '../types.js';

import { formatByLocale } from 'utils/date';

const useGetMaxCLASettingsTableData = () => {
  const { t } = useTranslation();
  const { data, isFetching } = useGetMaxCLASettings();
  const [convertedData, setConvertedData] =
    useState<ConvertedMaxCLASetting[]>();

  useEffect(() => {
    if (!isNil(data)) {
      setConvertedData(
        data.map<ConvertedMaxCLASetting>((maxCLASetting: MaxCLASetting) => ({
          ...maxCLASetting,
          type:
            maxCLASetting.type === 'MAX_BUH'
              ? t('max_buh.grid.claType.max_buh')
              : t('max_buh.grid.claType.max_sleeping_allowance'),
          from: formatByLocale(new Date(maxCLASetting.valid.from)),
          to: formatByLocale(new Date(maxCLASetting.valid.to))
        }))
      );
    }
  }, [data]);

  return { convertedData, isFetching };
};

export default useGetMaxCLASettingsTableData;
